import React, { useState, useEffect } from "react";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import api from "../../services/api";

import Swal from "sweetalert2";

const CampaignCoverList = (props) => {
    const [campaignCovers, setCampaignCovers] = useState([]);
    const [campaignCoversToShow, setCampaignCoversToShow] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(function () {
        loadList();
    }, []);

    async function loadList() {
        setLoaded(false);

        const responseGetCampaignCovers = await api.get("/campaign-cover");

        setCampaignCovers(responseGetCampaignCovers.data.data);
        setCampaignCoversToShow(responseGetCampaignCovers.data.data);
        setLoaded(true);
    }

    function handleSearchBar() {
        setLoaded(false);

        const originalCampaignCovers = campaignCovers;

        if (searchText === "") {
            setCampaignCoversToShow(originalCampaignCovers);
            setLoaded(true);
            return;
        }

        let filteredCampaignCovers = originalCampaignCovers.filter(
            (campaignCover) =>
                campaignCover.name
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) !== -1
        );

        if (filteredCampaignCovers.length <= 0) {
            filteredCampaignCovers = originalCampaignCovers.filter(
                (campaignCover) =>
                    campaignCover.name
                        .toLowerCase()
                        .indexOf(searchText.toLowerCase()) !== -1
            );
        }

        setCampaignCoversToShow(filteredCampaignCovers);
        setLoaded(true);
    }

    async function handleDelete(campaignCoverDelete) {
        Swal.fire({
            title: `Tem certeza que deseja excluir a capa da campanha ${campaignCoverDelete.name}?`,
            text: "Não será possível voltar atrás!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, quero excluir!",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (!result.value) {
                Swal.fire(
                    "Cancelado!",
                    "Nenhum dado será excluído.",
                    "success"
                );
            } else {
                setLoaded(false);

                try {
                    const responseDeleteCampaignCover = await api.delete(
                        `/campaign-cover/${campaignCoverDelete._id}`
                    );

                    if (responseDeleteCampaignCover.status === 204) {
                        const newCampaignCovers = campaignCovers.filter(
                            (campaignCover) =>
                                campaignCover._id !== campaignCoverDelete._id
                        );
                        setCampaignCovers(newCampaignCovers);
                        setCampaignCoversToShow(newCampaignCovers);
                        setLoaded(true);
                    } else {
                        throw new Error("Error");
                    }
                } catch (error) {
                    setLoaded(true);
                    Swal.fire({
                        type: "error",
                        title: "Oops...",
                        text: "Tivemos um problema ao excluir essa capa da campanha. Contate o suporte!",
                    });
                }
            }
        });
    }

    return (
        <Layout
            menuActive="registers"
            pageTitle="Lista de Capas das Campanhas"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                Lista de Capas das Campanhas
                            </div>
                            <ul className="card-action">
                                <li>
                                    <Link
                                        to="/capas-campanhas/nova"
                                        className="btn btn-sm btn-success"
                                    >
                                        Nova <i className="fa fa-plus"></i>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Opções</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {campaignCoversToShow.map(
                                                (campaignCover, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    campaignCover.name
                                                                }
                                                            </td>
                                                            <td>
                                                                <div className="col-xs-12">
                                                                    <div className="col-xs-12">
                                                                        <button
                                                                            className="btn btn-xs btn-danger"
                                                                            style={{
                                                                                width: "100%",
                                                                            }}
                                                                            onClick={() =>
                                                                                handleDelete(
                                                                                    campaignCover
                                                                                )
                                                                            }
                                                                        >
                                                                            Excluir
                                                                            <div className="icon fa fa-trash-o"></div>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(CampaignCoverList);
